import { cn } from '@/shared/utils';

import Finished from '@/components/livescoring/Finished';
import Livegames from '@/components/livescoring/Live';
import TopScores from '@/components/livescoring/TopScores';
import Button from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import useLivescoring from '@/hooks/livescoring/useLivescoring';
import { useTrackPageView } from '@/services/track';

const tabsClassName = cn(
  'rounded-3xl text-primary border-2 border-transparent bg-transparent',
  'data-[state=active]:text-primary data-[state=active]:border-primary'
);

const Livescoring = () => {
  useTrackPageView();
  const { bannerImg, currentBC, activeTab, handleTabChange } = useLivescoring();

  return (
    <>
      {currentBC && (
        <div
          className={cn(
            'py-2 px-3 flex-1 text-center w-screen',
            'max-xl:bg-black/50 max-xl:backdrop-blur-sm',
            'xl:sticky xl:-mt-[84px]',
            'xl:top-0 xl:left-1/2 xl:-translate-x-1/2 xl:py-5 xl:z-20',
            'xl:max-w-[450px] 2xl:max-w-[720px]'
          )}
        >
          <p className="xl:text-xl font-semibold leading-6">
            {currentBC.companyName}
          </p>
          <div className="flex items-center gap-2 justify-center">
            <img
              loading="lazy"
              src={
                currentBC.countryFlag ||
                `https://flagsapi.com/${currentBC.countryCode.toUpperCase()}/shiny/64.png`
              }
              alt="flag of the country"
              className="w-4"
            />
            <p className="text-sm text-secondary truncate">
              {currentBC.address}
            </p>
          </div>
        </div>
      )}

      {bannerImg && (
        <section
          className="h-[calc(100vh/5)] overflow-hidden"
          data-cy="top-banner"
        >
          <img
            src={bannerImg}
            alt="Lanetalk banner"
            className="w-full h-full object-contain"
          />
        </section>
      )}

      <Tabs
        value={activeTab}
        className="py-4 px-4"
        onValueChange={handleTabChange}
      >
        <TabsList className="p-0 bg-transparent md:gap-4 h-11">
          <TabsTrigger value="live" asChild>
            <Button className={tabsClassName}>Live</Button>
          </TabsTrigger>
          <TabsTrigger value="finished" asChild>
            <Button className={tabsClassName}>Finished</Button>
          </TabsTrigger>
          <TabsTrigger value="scores" asChild>
            <Button className={tabsClassName}>Top scores</Button>
          </TabsTrigger>
        </TabsList>
        <TabsContent value="live" className="relative">
          <Livegames />
        </TabsContent>
        <TabsContent value="finished">
          <Finished />
        </TabsContent>
        <TabsContent value="scores">
          <TopScores />
        </TabsContent>
      </Tabs>
    </>
  );
};

export default Livescoring;
